var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['child-btn', _vm.background && 'show-back'],on:{"click":function($event){return _vm.childBtnClick()}}},[_vm._v(" "+_vm._s(_vm.twoMenu.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }